










import { Component, Vue } from 'vue-property-decorator'
import UnderMaintenance from './components/UnderMaintenance/index.vue'
import { firebaseDB } from './firebase'

@Component({
  components: {
    UnderMaintenance
  }
})
export default class CouponList extends Vue {
  public underMaintenance: boolean = false
  mounted() {
    const doc = firebaseDB
      .collection('UnderMaintenance')
      .doc('useUnderMaintenance')
    doc.get().then(snapshot => {
      if (snapshot.exists) {
        this.underMaintenance = snapshot.get('underMaintenance')
      } else {
        this.underMaintenance = false
      }
    })
  }
}
